import { CompanyModel } from '../management/company.model';
import { ProfileUserModel } from './profile-user.model';

export class UserModel {
  userId: number = 0;
  userName: string = '';
  firstName: string = '';
  lastName: string = '';
  profileUserId: number = 0;
  profileUser: ProfileUserModel = new ProfileUserModel();
  principalBranchId: number = 0;
  active: boolean = true;
  email: string | null = null;
  rateDiscountMax: number = 0;
  accessAllCostCenters: boolean = true;
  passwordHash: string = '';
  rolId: number = 0;
  accessApp: boolean = true;
  accesWeb: boolean = true;
  viewAllOrders: boolean = true;
  createDate: string | null = null;
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
  companyId: number = 0;
  company: CompanyModel | null = null;
  branches: any[] = [];
}